import {useMemo} from 'react';

import {getSmartNotificationForLead} from './smart-finder';
import {type ILead, type IMessage} from 'src/services/api';
import {type ISmartNotification} from './types';
import {type IShowing} from 'src/api/landlord-showings-api';

interface Props {
    lead?: ILead;
    messages?: IMessage[];
    showings?: IShowing[];
}

export const useSmartNotifications = (props: Props): ISmartNotification | undefined => {
    return useMemo(() => {
        const {lead, messages, showings} = props;
        if (!lead || !messages || !showings) {
            return;
        }

        return getSmartNotificationForLead(lead, messages, showings);
    }, [props]);
};
